ACC.commoninput = {

  bindAll: function() {
    this.bindInputOption();
    this.disableEnterKey();
  },
  bindInputOption: function() {
    $(document).on('blur', '.ph-forminput', function() {
      ACC.commoninput.checkfunction($(this));
    });
    $('.ph-forminput.date').on('change', function() {
      ACC.commoninput.checkfunction($(this));
    });
  },
  checkfunction: function($this) {
    /** *** Label fix for IE browser by Nithin V *****/
    if (window.navigator.userAgent.includes('MSIE ') > 0 || window.navigator.userAgent.includes('Trident/') > 0) {
      $this.parent().find('.ph-formlabel').addClass('ph-ielabel');
    } else {
      $this.parent().find('.ph-formlabel').removeClass('ph-ielabel');
    }
  },
  disableEnterKey: function() {
    $(document).on('keyup keypress', '.disable_enterkey', function(e) {
      var keyCode = e.keyCode || e.which;

      if (keyCode === 13) {
        e.preventDefault();
      }
    });
  }
};

$(document).ready(function() {
  ACC.commoninput.bindAll();
});
